import { UserContextState } from '../../contexts/UserContext';
import Merchant from '../../domain/entities/Merchant';

export const showOwnMerchantPageBy = (
  auth: UserContextState['auth'],
  merchant: Merchant,
) => {
  // login
  if (!auth.user) {
    return false;
  }
  // the merchant show own page
  if (merchant.publicId === auth.user.publicId) {
    return true;
  }
  // others
  return false;
};
